import { render, staticRenderFns } from "./Form_Details.vue?vue&type=template&id=b5049e8c"
import script from "./Form_Details.vue?vue&type=script&lang=js"
export * from "./Form_Details.vue?vue&type=script&lang=js"
import style0 from "./Form_Details.vue?vue&type=style&index=0&id=b5049e8c&prod&lang=css"
import style1 from "./Form_Details.vue?vue&type=style&index=1&id=b5049e8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports